import React, { Component } from "react";
import Novelties from "../../../components/Novelties/Novelties";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : LicensesForm
Description : Compoente que alberga el formulario de Licenses definido en el directorio de componentes
Date Autor Modification
================================================================================
29/09/2022 Santiago Coca - Se define el componente
================================================================================ */

class NoveltiesForm extends Component {
    render() {
        return (
            <Novelties />
        )
    }
}

export default NoveltiesForm;